const ToggleTabs = (tabs, currentTab, tabsContent) => {
  tabs.forEach((tab) => {
    tab.closest('li').classList.remove('--active')
  })
  tabsContent.forEach((tabContent) => {
    tabContent.classList.remove('--active')
  })
  currentTab.closest('li').classList.add('--active')
  document.querySelector(`[tab-content="${currentTab.getAttribute('tab')}"]`).classList.add('--active')
}

const Tabs = () => {
  const tabs = document.querySelectorAll('[tab]')
  const tabsContent = document.querySelectorAll('[tab-content]')

  if(!tabs) return

  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault()

      ToggleTabs(tabs, e.currentTarget, tabsContent)
    })
  })
}
export default Tabs
